import React from 'react';
import Script from 'react-load-script';
import Bugsnag from 'bugsnag-js';

import { configEnabled } from 'decisiv-domain-utils';

import { getBrandFromUrl } from 'utils/url';

function enableZenDesk() {
  return configEnabled('ZENDESK_ENABLED');
}

function scriptUrl() {
  const brand = getBrandFromUrl();
  const envVar = `ZENDESK_${brand.toUpperCase()}_KEY`;
  const zendeskKey = process.env[envVar];
  if (!zendeskKey) {
    const errorMsg = `
      Cannot find Zendesk API key for brand '${brand}' - missing environment variable '${envVar}'
    `;
    // eslint-disable-next-line no-console
    console.error(errorMsg);
    Bugsnag.notify('Zendesk config error', errorMsg, { brand, envVar }, 'error');
  }

  return `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
}

function configureZendesk() {
  window.zESettings = {
    webWidget: {
      helpCenter: {
        filter: { label_names: 'fleet' },
      },
    },
  };

  window.zE(() => {
    window.zE.setHelpCenterSuggestions({ url: true });
  });
}

function ZendeskLoader() {
  if (enableZenDesk()) {
    return (
      <Script
        url={scriptUrl()}
        attributes={{ id: 'ze-snippet' }}
        onLoad={configureZendesk}
      />
    );
  }

  return null;
}

export default ZendeskLoader;



// WEBPACK FOOTER //
// ./setup/ZendeskLoader.js